import paymentJobService from 'Services/PaymentJobService'

// initial state
const state = {
  paymentJobs: []
}

// getters
const getters = {
  paymentJob: state => reference => state.paymentJobs.find(paymentJob => paymentJob.reference === reference)
}

const actions = {
  filterPaymentJobs: ({ commit }, { context, filterContext }) => {
    const { request, cancelToken } = paymentJobService.getAll(context, filterContext)

    const promise = new Promise((resolve, reject) => {
      request.then(result => {
        commit('setPaymentJobs', result.data)
        resolve(result)
      }).catch(error => {
        reject(error)
      })
    })

    return { promise, cancelToken }
  },

  getPaymentJobs: ({ dispatch }, { context }) => {
    return dispatch('filterPaymentJobs', { context }).then(({ promise }) => promise.then(result => result.data))
  },

  getPaymentJob: ({ commit }, { context, reference }) => {
    return new Promise((resolve, reject) => {
      paymentJobService.get(context, reference).then(result => {
        commit(state.paymentJobs.some(item => item.reference === result.data.reference) ? 'updatePaymentJob' : 'setPaymentJob', result.data)
        resolve(result.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updatePaymentJob: ({ dispatch }, { context, reference, paymentJob }) => {
    return new Promise((resolve, reject) => {
      paymentJobService.update(context, reference, paymentJob).then(() => {
        return dispatch('getPaymentJob', { context, reference }).then(result => resolve(result))
      }).catch(error => {
        reject(error)
      })
    })
  }
}

// mutations
const mutations = {
  setPaymentJobs (state, paymentJobs) {
    state.paymentJobs = paymentJobs
  },

  setPaymentJob (state, paymentJob) {
    state.paymentJobs.push(paymentJob)
  },

  updatePaymentJob (state, paymentJob) {
    state.paymentJobs = state.paymentJobs.map(item =>
      item.reference === paymentJob.reference ? paymentJob : item
    )
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
